import { createSelector } from "reselect";

export const publishRequestsSelector = createSelector(
    state => state.configCI.publishRequests,
    state => state
);

export const publishRequestsTestCasesSelector = createSelector(
    state => state.configCI.publishRequests.testCases,
    state => state
);

export const acceptPublishRequestDialogSelector = createSelector(
    state => state.configCI.publishRequests.acceptPublishRequestDialog,
    state => state
);
